export const CPF_MASK = '000.000.000-00';
export const CNPJ_MASK = '00.000.000/0000-00';
export const PHONE_LANDLINE_MASK = '(00) 0000-0000';
export const PHONE_MASK = '(00) 0 0000-0000';
export const PHONE_MASK_DINAMIC = `${PHONE_LANDLINE_MASK}||${PHONE_MASK}`;
export const CEP_MASK = '00000-000';
